import { render } from "./Pedido_Archivo.vue?vue&type=template&id=872e3e84&scoped=true"
import script from "./Pedido_Archivo.vue?vue&type=script&lang=js"
export * from "./Pedido_Archivo.vue?vue&type=script&lang=js"

import "./Pedido_Archivo.vue?vue&type=style&index=0&id=872e3e84&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872e3e84"]])

export default __exports__